// import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
// import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import DuoIcon from "@mui/icons-material/Duo";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import TodayOutlinedIcon from "@mui/icons-material/TodayOutlined";
import {
  AppBar,
  Avatar,
  // Badge,
  Box,
  Chip,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tab,
  Tabs,
  // SvgIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React, { Suspense, useRef, useState } from "react";
// import { useNavigate } from "react-router-dom";
import { NAV_PROFILE_ACTION } from "@/constants/admin-layout";
import { HelpCenterModal } from "@/layout/help-center";
import { Add } from "@mui/icons-material";
import logo from "../../../assets/eCarehealth-White-logo.svg";
import { NavDataType } from "../../../constants/common";
import useCurrentUser from "../../../hooks/local-storage/use-current-user";
import { DisclosureHost } from "../../../hooks/use-disclosure";
import { useReduceDisclosure } from "../../../hooks/use-reduce-disclosure";
import AddPatientDrawer from "../../../pages/app/provider/patient/AddPatient";
import InstantAppointMentModal from "../../../pages/app/provider/scheduling/InstantAppointMentModal";
import NewAppointment from "../../../pages/app/provider/scheduling/appointment/NewAppointment";
import { FallBackComp } from "../../../pages/app/provider/scheduling/appointment/encounter/content-section/IntakeFormData";
import { useProviderProfile } from "../../../queries/provider/setting/use-provider-profile";
import { useUserProfile } from "../../../queries/use-user-profile";
import lazyWithRetry from "../../../utils/lazy-with-retry";
import {
  // DEFAULT_USER_SRC,
  getIdFromObj,
  getUserAlias,
  getValueFromObj,
  getXtenantId,
  NAVBAR,
} from "../../../utils/utils";
import CustomSelect from "../../CustomSelect";
import Flex from "../../Flex";
import SuccessModal, { useSuccess } from "../../SuccessModal";
import Text from "../../Text";
import { useRoleController } from "../../useRoleController";
import UploadData from "../admin/Library/UploadData";
import { CHART_COLORS, CHART_TYPOGRAPHY } from "../provider/patient/chart";
import NavAddPatientModal from "./NavAddPatientModal";
import Notification from "./notification/Notification";
import { getProviderGroupName } from "@/utils/auth-storage";
const SpotLight = lazyWithRetry(() => import("../SpotLight"));

interface NavBarProps {
  navOptions: NavDataType[];
  handleProfileClick: (profileData: NavDataType) => void;
  anchorElUser: HTMLElement | null;
  active: string;
  subMenuItems?: NavDataType[];
  handleCloseUserMenu: (subMenuItems?: NavDataType) => void;
  onClickMenuItem: (
    menu: NavDataType,
    event: React.MouseEvent<HTMLElement>
  ) => void;
  profileData: NavDataType[];
  view: "admin" | "provider" | "staff";
}

const navheight = 36;

export const NAVBAR_HEIGHT = `${navheight}px`;

export const NAVBAR_HEIGHT_PLUS15 = `${navheight + 15}px`;

const NavBar: React.FC<NavBarProps> = ({
  view,
  navOptions,
  anchorElUser,
  active,
  handleCloseUserMenu,
  onClickMenuItem,
  handleProfileClick,
  profileData,
}) => {
  // const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState<string>(active);
  const profileAnchorRef = useRef<HTMLDivElement>(null);
  const [isHelpCenterOpen, setIsHelpCenterOpen] = useState(false);
  const [me] = useCurrentUser();
  const providerGroupId = getProviderGroupName() ?? undefined;
  // Staff users are routed into the provider view, so `view` alone cannot tell
  // them apart from an actual provider.
  const isStaffUserLoggedIn = me?.roleType === "STAFF";
  const isProviderUserLoggedIn = view === "provider" && !isStaffUserLoggedIn;

  const { data }: any = useProviderProfile(
    getXtenantId() ?? undefined,
    isProviderUserLoggedIn
  );

  // const { data } = useProvider({
  //   providerUuid: me?.uuid,
  //   tenantId: providerGroupId ?? undefined,
  // });

  const [
    patientDisclosure,
    uploadDetailModal,
    newAppointmentDisclosure,
    addPatientDisc,
    spotLightDisclosure,
    instantAppointmentDisclosure,
  ] = useReduceDisclosure(6);
  const [
    openedEhrSuccessModal,
    { open: openEhrSuccessModal, close: closeEhrSuccessModal },
  ] = useSuccess();
  const { data: adminProfileData } = useUserProfile({
    disabled: isProviderUserLoggedIn,
  });

  const OpenActionModalsMapper: Record<ViewType, DisclosureHost> = {
    patient: patientDisclosure,
    appointment: newAppointmentDisclosure,
    "instant-appointment": instantAppointmentDisclosure,
  };

  return (
    <AppBar
      sx={{
        zIndex: 90,
        height: NAVBAR_HEIGHT,
        boxShadow: "none !important",
        px: "24px",
        py: 0,
        backgroundColor: CHART_COLORS.navbarPrimaryBg,
      }}
      position="sticky"
    >
      <Flex alignItems={"center"} position={"relative"} mx={0} height={"100%"}>
        <img
          src={logo}
          alt="Company-Logo"
          width={NAVBAR.LOGO_WIDTH}
          height={NAVBAR.LOGO_HEIGHT}
        />
        <Tabs
          sx={{
            // border:'2px solid',
            "& .MuiButtonBase-root": {
              // padding: 0,
              // minWidth: 0,
              // marginRight: "16px",
              opacity: 1,
              "&:hover": {
                opacity: 0.6,
              },
            },
            marginLeft: "20px",
          }}
          textColor={"inherit"}
          TabIndicatorProps={{
            sx: {
              marginBottom: "8px",
              bgcolor: "white",
            },
          }}
          variant={"scrollable"}
          value={active}
        >
          {navOptions.map((tab) => {
            return (
              <Tab
                // disabled={tab.value === "dashboard"}
                key={tab.value}
                // sx={{ marginRight: "16px" }}
                value={tab.value}
                onClick={(e) => {
                  onClickMenuItem(tab, e);
                  setCurrentTab(tab.value);
                }}
                // onMouseOver={(e) => {
                //   onClickMenuItem(tab, e);
                //   setCurrentTab(tab.value);
                // }}
                // onMouseLeave={() => {
                //   handleCloseUserMenu();
                // }}
                label={
                  <Flex alignItems="center" gap={1}>
                    <Text fontSize={NAVBAR.TAB_FONT_SIZE} c={NAVBAR.TAB_COLOR}>
                      {tab.label}
                    </Text>
                    {tab.children &&
                      tab.children.length > 0 &&
                      (currentTab === tab.value && Boolean(anchorElUser) ? (
                        <ExpandLessIcon
                          sx={{
                            color: NAVBAR.EXPAND_ICON_COLOR,
                            fontSize: NAVBAR.EXPAND_ICON_SIZE,
                          }}
                        />
                      ) : (
                        <ExpandMoreIcon
                          sx={{
                            color: NAVBAR.EXPAND_ICON_COLOR,
                            fontSize: NAVBAR.EXPAND_ICON_SIZE,
                          }}
                        />
                      ))}
                  </Flex>
                }
              />
            );
          })}
        </Tabs>

        <Menu
          sx={{ mt: "25px" }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          // MenuListProps={{ onMouseLeave: () => handleCloseUserMenu() }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser)}
          onClose={() => handleCloseUserMenu()}
        >
          <Flex flexDirection={"column"} px={2}>
            {/* <Text mb={1} color={"primary"}>
              {replaceUnderScoreAddSpace(currentTab)}
            </Text> */}
            {navOptions
              ?.find((it) => it.value === currentTab)
              ?.children?.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => handleCloseUserMenu(option)}
                >
                  <Text
                    fontSize={NAVBAR.MENU_ITEM_FONT_SIZE}
                    color={NAVBAR.MENU_ITEM_COLOR}
                    textAlign="center"
                  >
                    {option.label}
                  </Text>
                </MenuItem>
              ))}
          </Flex>
        </Menu>

        {/* Search, Create, and SpotLight */}
        <Flex
          height={"40px"}
          alignItems={"center"}
          gap={"20px"}
          marginLeft={"auto"}
        >
          {view === "provider" && (
            <Flex
              height={"40px"}
              alignItems={"center"}
              gap={"20px"}
              marginLeft={"auto"}
            >
              <Tooltip
                title="Search Patient by First Name, Last Name"
                followCursor
              >
                <IconButton
                  size="small"
                  style={{ color: "#fff" }}
                  onClick={() => spotLightDisclosure.open()}
                >
                  <img src="/search.svg" alt="" />
                </IconButton>
              </Tooltip>

              <Suspense fallback={<FallBackComp />}>
                <SpotLight disclosureHost={spotLightDisclosure} />
              </Suspense>

              {/* <Divider
              orientation="vertical"
              flexItem
              sx={{ borderColor: "rgba(255,255,255,0.3)", my: 1 }}
            /> */}

              <NavBarActionPopUpAction
                onClick={(v) => OpenActionModalsMapper[v].open()}
              />
              <InstantAppointMentModal
                disclosureHost={instantAppointmentDisclosure}
              />
            </Flex>
          )}

          <NavAddPatientModal
            disclosureHost={patientDisclosure}
            onNextClick={(v) => {
              if (v === "csv") uploadDetailModal.open();
              else if (v === "ehr") {
                openEhrSuccessModal();
                //Todo api call for ehr
                patientDisclosure.close();
              } else if (v === "patient") {
                addPatientDisc.open();
                // navigate("/app/provider/patients/add-patient");
                patientDisclosure.close();
              }
            }}
          />

          <AddPatientDrawer disclosureHost={addPatientDisc} />

          {newAppointmentDisclosure.opened && (
            <NewAppointment
              opened={newAppointmentDisclosure.opened}
              onClose={newAppointmentDisclosure.close}
            />
          )}

          <SuccessModal
            label="The invitation link has been sent successfully to your email."
            opened={openedEhrSuccessModal}
            onClose={closeEhrSuccessModal}
          />

          <UploadData
            modalTitle="Import Patients"
            open={uploadDetailModal.opened}
            onClose={uploadDetailModal.close}
          />

          <Flex
            gap={1.8}
            ml={1.8}
            alignItems={"center"}
            height={"40px"}
            marginLeft={"auto"}
          >
            {/* Chat icon, Notification */}
            {view === "provider" && (
              // <IconButton
              //   style={{ color: "#fff" }}
              //   onClick={() => navigate("/app/provider/communications")}
              // >
              //   <Badge
              //     badgeContent={0}
              //     max={9999}
              //     color="error"
              //     sx={{
              //       "& .MuiBadge-badge": {
              //         width: "20px",
              //         height: "20px",
              //         backgroundColor: "#E1FCDE",
              //         color: "#049B22",
              //       },
              //     }}
              //   >
              //     <SvgIcon sx={{ fontSize: 24 }} viewBox="0 0 21 19">
              //       <path
              //         d="M18.8218 0H1.56851C1.15252 0 0.753571 0.16525 0.459424 0.459397C0.165277 0.753543 2.73105e-05 1.15249 2.73105e-05 1.56848V17.2533C-0.00174492 17.5522 0.0827707 17.8453 0.243436 18.0975C0.404101 18.3496 0.634094 18.55 0.905824 18.6747C1.11347 18.7711 1.33957 18.8213 1.56851 18.8217C1.93671 18.8209 2.2927 18.6896 2.57331 18.4512L2.58213 18.4443L5.78379 15.6848H18.8218C19.2378 15.6848 19.6367 15.5195 19.9308 15.2254C20.225 14.9312 20.3902 14.5323 20.3902 14.1163V1.56848C20.3902 1.15249 20.225 0.753543 19.9308 0.459397C19.6367 0.16525 19.2378 0 18.8218 0ZM18.8218 14.1163H5.4897C5.3014 14.1164 5.11941 14.1843 4.97701 14.3075L1.56851 17.2533V1.56848H18.8218V14.1163ZM6.27394 6.27391C6.27394 6.06592 6.35657 5.86645 6.50364 5.71937C6.65071 5.5723 6.85019 5.48967 7.05818 5.48967H13.3321C13.5401 5.48967 13.7396 5.5723 13.8866 5.71937C14.0337 5.86645 14.1163 6.06592 14.1163 6.27391C14.1163 6.48191 14.0337 6.68138 13.8866 6.82845C13.7396 6.97553 13.5401 7.05815 13.3321 7.05815H7.05818C6.85019 7.05815 6.65071 6.97553 6.50364 6.82845C6.35657 6.68138 6.27394 6.48191 6.27394 6.27391ZM6.27394 9.41087C6.27394 9.20288 6.35657 9.0034 6.50364 8.85633C6.65071 8.70925 6.85019 8.62663 7.05818 8.62663H13.3321C13.5401 8.62663 13.7396 8.70925 13.8866 8.85633C14.0337 9.0034 14.1163 9.20288 14.1163 9.41087C14.1163 9.61886 14.0337 9.81834 13.8866 9.96541C13.7396 10.1125 13.5401 10.1951 13.3321 10.1951H7.05818C6.85019 10.1951 6.65071 10.1125 6.50364 9.96541C6.35657 9.81834 6.27394 9.61886 6.27394 9.41087Z"
              //         fill="white"
              //       />
              //     </SvgIcon>
              //   </Badge>
              // </IconButton>
              <></>
            )}

            {/* <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: "rgba(255,255,255,0.3)", my: 1 }}
          /> */}

            <Notification />

            {/* <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: "rgba(255,255,255,0.3)", my: 1 }}
          /> */}
          </Flex>
          <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
              <React.Fragment>
                <Flex
                  textAlign={"center"}
                  alignItems={"center"}
                  gap={0.5}
                  style={{ cursor: "pointer" }}
                  {...bindTrigger(popupState)}
                >
                  <Avatar
                    ref={profileAnchorRef}
                    alt="admin image"
                    src={data?.data?.avatar ?? adminProfileData?.data?.avatar}
                    sx={{
                      width: NAVBAR.AVATAR_SIZE,
                      height: NAVBAR.AVATAR_SIZE,
                      fontSize: NAVBAR.AVATAR_FONT_SIZE,
                      bgcolor: NAVBAR.AVATAR_BG,
                      color: NAVBAR.AVATAR_COLOR,
                    }}
                  >
                    {getUserAlias(
                      data?.data?.firstName ||
                        adminProfileData?.data?.firstName,
                      data?.data?.lastName || adminProfileData?.data?.lastName
                    )}
                  </Avatar>
                  {/* {popupState.isOpen ? (
                    <ExpandLessIcon sx={{ color: "#fff", fontSize: 20 }} />
                  ) : (
                    <ExpandMoreIcon sx={{ color: "#fff", fontSize: 20 }} />
                  )} */}
                </Flex>
                <Menu {...bindMenu(popupState)}>
                  <Flex
                    mt={1.2}
                    boxSizing={"border-box"}
                    width={"300px"}
                    height={view === "provider" ? "400px" : "334px"}
                    justifyContent={"space-between"}
                    flexDirection={"column"}
                  >
                    <Flex
                      alignItems={"center"}
                      justifyContent={"center"}
                      flexDirection={"column"}
                      gap={1}
                    >
                      <Avatar
                        alt="admin image"
                        src={
                          data?.data?.avatar ??
                          me?.avatar ??
                          adminProfileData?.data?.avatar
                        }
                        sx={{
                          width: NAVBAR.AVATAR_LARGE_SIZE,
                          height: NAVBAR.AVATAR_LARGE_SIZE,
                          fontSize: NAVBAR.AVATAR_LARGE_FONT_SIZE,
                          bgcolor: NAVBAR.AVATAR_BG,
                          color: NAVBAR.AVATAR_COLOR,
                        }}
                      >
                        {getUserAlias(
                          data?.data?.firstName ||
                            adminProfileData?.data?.firstName,
                          data?.data?.lastName ||
                            adminProfileData?.data?.lastName
                        )}
                      </Avatar>
                      <Text fontWeight={"bold"} variant="h4">
                        {data?.data?.firstName || data?.data?.lastName
                          ? `${data?.data?.firstName ?? ""} ${data?.data?.lastName ?? ""}`
                          : `${adminProfileData?.data?.firstName ?? ""} ${
                              adminProfileData?.data?.lastName ?? ""
                            }`}
                      </Text>

                      <Chip
                        size="small"
                        style={{
                          backgroundColor: "#EEF7FD",
                          color: "#0097F0",
                        }}
                        label={
                          data?.data?.role ??
                          adminProfileData?.data?.roleString ??
                          adminProfileData?.data?.role ??
                          ""
                        }
                      />
                    </Flex>
                    {view === "provider" && (
                      <Flex
                        gap={2}
                        flexDirection={"column"}
                        p={3}
                        boxSizing={"border-box"}
                      >
                        <CustomSelect
                          readOnly
                          value={providerGroupId ?? ""}
                          label={"PROVIDER GROUP"}
                          options={[
                            {
                              value: providerGroupId ?? "",
                              label: providerGroupId ?? "",
                            },
                          ]}
                        />
                        <CustomSelect
                          readOnly
                          label={"LOGGED LOCATION"}
                          value={getIdFromObj(me?.workLocations) ?? ""}
                          options={[
                            {
                              value: getIdFromObj(me?.workLocations) ?? "",
                              label: getValueFromObj(me?.workLocations) ?? "",
                            },
                          ]}
                        />
                      </Flex>
                    )}
                    <Box>
                      <Divider sx={{ marginY: "5px" }} />
                      {profileData.map((item) => {
                        return (
                          <MenuItem
                            sx={{ marginTop: "8px" }}
                            onClick={() => {
                              if (item.value !== NAV_PROFILE_ACTION.LOG_OUT)
                                popupState.close();
                              if (item.value === NAV_PROFILE_ACTION.HELP)
                                setIsHelpCenterOpen(true);

                              handleProfileClick(item);
                            }}
                            key={item.value}
                          >
                            {item?.icon && (
                              <ListItemIcon>
                                <item.icon fontSize="small" />
                              </ListItemIcon>
                            )}
                            <Typography>{item.label}</Typography>
                          </MenuItem>
                        );
                      })}
                    </Box>
                  </Flex>
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
          <HelpCenterModal
            open={isHelpCenterOpen}
            anchorEl={profileAnchorRef.current}
            onClose={() => setIsHelpCenterOpen(false)}
          />
        </Flex>
      </Flex>
    </AppBar>
  );
};

export default NavBar;

type ViewType = "patient" | "appointment" | "instant-appointment";

interface NavBarActionPopUpActionProps {
  onClick: (v: ViewType) => void;
}

const NavBarActionPopUpAction = ({ onClick }: NavBarActionPopUpActionProps) => {
  const { hasUpdate: hasPatientRegistrationUpdate } = useRoleController(
    "Patient Registration"
  );
  const { hasUpdate: hasAppointmentSchedulingUpdate } = useRoleController(
    "Appointment Scheduling"
  );
  const { hasUpdate: hasUpdateInstantAppointment } = useRoleController(
    "Instant Appointment"
  );
  const handleClick = (menuList: any, v: ViewType) => {
    onClick(v);
    menuList.close();
  };

  type CreateMenu = { value: ViewType; isPermission: boolean; icon: any };
  const CREATE_MENU_ITEMS: CreateMenu[] = [
    {
      value: "patient",
      isPermission: hasPatientRegistrationUpdate,
      icon: PersonAddOutlinedIcon,
    },
    {
      value: "appointment",
      isPermission: hasAppointmentSchedulingUpdate,
      icon: TodayOutlinedIcon,
    },
    {
      value: "instant-appointment",
      isPermission: hasUpdateInstantAppointment,
      icon: DuoIcon,
    },
  ];

  return (
    <>
      {(hasPatientRegistrationUpdate ||
        hasAppointmentSchedulingUpdate ||
        hasUpdateInstantAppointment) && (
        <PopupState variant="popover" popupId="create-navbar-button-menu">
          {(menuList) => (
            <>
              <Box
                borderRadius={1}
                bgcolor={"white"}
                // px={1.2}
                pl={"5.5px"}
                // py={1}
                {...bindTrigger(menuList)}
                sx={{ cursor: "pointer" }}
                width={"99px"}
                height={"26px"}
              >
                <Flex alignItems={"center"} gap={0.8} height={"26px"} pr={0}>
                  <Add style={{ fontSize: "18px" }} color="primary" />
                  <Text
                    fontSize={CHART_TYPOGRAPHY.body5.fontSize}
                    variant="button"
                    c={"primary.main"}
                    mr={0}
                    fontWeight={400}
                  >
                    Create
                  </Text>
                  {/* <Divider
                      orientation="vertical"
                      sx={{
                        opacity: 0.5,
                        border: "1px solid",
                        borderColor: "primary.main",
                      }}
                    /> */}
                  {bindMenu(menuList).open ? (
                    <ExpandLessIcon sx={{ fontSize: "18px" }} color="primary" />
                  ) : (
                    <ExpandMoreIcon sx={{ fontSize: "18px" }} color="primary" />
                  )}
                </Flex>
              </Box>
              <Menu {...bindMenu(menuList)}>
                {CREATE_MENU_ITEMS?.map((menu: CreateMenu) => {
                  return (
                    menu?.isPermission && (
                      <MenuItem
                        onClick={() => handleClick(menuList, menu.value)}
                        key={menu.value}
                      >
                        <Flex
                          gap={"10px"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <menu.icon
                            sx={{ fontSize: NAVBAR.MENU_ITEM_FONT_SIZE }}
                          />
                          <Typography fontSize={NAVBAR.MENU_ITEM_FONT_SIZE}>
                            {MENU_LABEL_MAPPER[menu.value]}
                          </Typography>
                        </Flex>
                      </MenuItem>
                    )
                  );
                })}
              </Menu>
            </>
          )}
        </PopupState>
      )}
    </>
  );
};

const MENU_LABEL_MAPPER: Record<ViewType, string> = {
  patient: "New Patient",
  appointment: "New Appointment",
  "instant-appointment": "Instant Appointment",
};
